// extracted by mini-css-extract-plugin
module.exports = {"menu-divider":"style_menu-divider__YBxuA"};